'use client';

import type { ReactNode } from 'react';

/**
 * Opens the live chat through the opener ChatWidget registers on `window`.
 * Carries `chat-launcher`, which globals.css shows only under `body.chat-online`
 * (an operator is on chat), so it never offers a chat nobody will answer.
 */
export function ChatButton({ children, className = '' }: { children: ReactNode; className?: string }) {
  return (
    <button type="button" onClick={() => window.__bceOpenChat?.()} className={`chat-launcher ${className}`}>
      {children}
    </button>
  );
}
